export default {
  namespaced: true,
  state: {
    baseURL: null,
    mediaURL: null,
    rowsPerPage: 10,
    admincompanyId: null,
  },
  getters: {
    getBaseUrl(state) {
      return state.baseURL;
    },
    getMediaUrl(state) {
      return state.mediaURL;
    },
    getRowsPerPage(state) {
      return state.rowsPerPage;
    },
    getCompanyId(state) {
      return state.admincompanyId;
    }
  },
  mutations: {
    SET_BASE_URL(state, data) {
      state.baseURL = data;
    },
    SET_MEDIA_URL(state, data) {
      state.mediaURL = data;
    },
    SET_COMPANY_ID(state, data) {
      state.admincompanyId = data;
    }
  },
  actions: {
    setBaseUrl({ commit }, url) {
      commit("SET_BASE_URL", url);
    },
    setMediaUrl({ commit }, url) {
      commit("SET_MEDIA_URL", url);
    },
    setCompayId({ commit }, companyId) {
      commit('SET_COMPANY_ID', companyId);
    }
  },
};
